import { Locale } from 'date-fns'
import * as Locales from 'date-fns/locale'

const isDateFnsSupportedLocale = (locale: string): locale is keyof typeof Locales =>
  Object.keys(Locales).includes(locale)

export const getDateFnsLocaleByLocaleString = (rawLocale?: string): Locale | undefined => {
  if (!rawLocale) {
    return undefined
  }

  // Full locale (e.g., "en-US" -> "enUS")
  const locale = rawLocale.replace('-', '')
  if (isDateFnsSupportedLocale(locale)) {
    return Locales[locale]
  }

  // Language code only (e.g., "en-US" -> "en")
  const languageCode = rawLocale.split('-')[0]
  if (isDateFnsSupportedLocale(languageCode)) {
    return Locales[languageCode]
  }

  // Default
  return Locales.enUS
}
